import * as React from "react";

import { Disclosure } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const TabsAccordion = ({ tabs }) => {
  return (
    <div className="w-full md:hidden accordion">
      {tabs.modular_blocks.map((tab) => (
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={classNames(
                  "accordion-button",
                  open ? "expanded" : ""
                )}
              >
                <h3>{tab.tab.title}</h3>
                <span className="accordion-icon"></span>
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pb-2 pt-4 text-sm text-gray-500 flex flex-col space-y-6">
                {tab.tab.modular_blocks.map((item) => (
                  <div
                    className="flex flex-col justify-center items-center w-full"
                    key={item.item.title}
                  >
                    <div className="w-full aspect-square">
                      <img
                        src={item.item.file.url}
                        alt={item.item.title}
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <span className="text-center item-title">
                      {item.item.title}
                    </span>
                  </div>
                ))}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      ))}
    </div>
  );
};

export default TabsAccordion;
